export default __webpack_public_path__ + "static/media/hht1_storybook_05.3b22c13e.png";